import React, {useContext} from "react";
import {Fade} from "react-reveal";
import "./Greeting.scss";
import {greeting, socialMediaLinks} from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";

import profileImage from "../../assets/images/srimon.jpg";

export default function Greeting() {
  const {isDark} = useContext(StyleContext);
  if (!greeting.displayGreeting) return null;

  const scrollTo = id => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({behavior: "smooth"});
  };

  return (
    <section className={`hero ${isDark ? "dark" : ""}`} id="greeting">
      {/* Ambient background orbs */}
      <div className="hero__orb hero__orb--1" aria-hidden="true" />
      <div className="hero__orb hero__orb--2" aria-hidden="true" />

      <div className="hero__inner">
        {/* ── Text ── */}
        <Fade bottom duration={800} distance="40px">
          <div className="hero__text">
            {/* Eyebrow — role title, plain text */}
            <p className="hero__eyebrow">{greeting.title}</p>

            {/* Display name */}
            <h1 className="hero__name">{greeting.username}</h1>

            {/* Available status — sits naturally below the name */}
            <div className="hero__status">
              <span className="hero__status-dot" aria-hidden="true" />
              <span>Open to GenAI Engineering roles</span>
            </div>

            {/* Headline */}
            <p className="hero__headline">{greeting.headline}</p>

            {/* Subline */}
            <p className="hero__sub">{greeting.subline}</p>

            {/* CTAs */}
            <div className="hero__cta">
              <button
                className="cta-primary"
                onClick={() => scrollTo("engineering")}
              >
                View Work
              </button>
              <a
                href={socialMediaLinks.github}
                target="_blank"
                rel="noopener noreferrer"
                className="cta-secondary"
              >
                GitHub ↗
              </a>
              <a
                href={`mailto:${socialMediaLinks.gmail}`}
                className="cta-secondary"
              >
                Email ↗
              </a>
            </div>

            {/* Quick stats */}
            <div className="hero__stats">
              <div className="hero__stat">
                <span className="hero__stat-val">1+</span>
                <span className="hero__stat-lbl">Years at Bosch</span>
              </div>
              <div className="hero__stat-divider" aria-hidden="true" />
              <div className="hero__stat">
                <span className="hero__stat-val">MSc</span>
                <span className="hero__stat-lbl">AI — BTU Cottbus</span>
              </div>
              <div className="hero__stat-divider" aria-hidden="true" />
              <div className="hero__stat">
                <span className="hero__stat-val">2×</span>
                <span className="hero__stat-lbl">Certified</span>
              </div>
            </div>
          </div>
        </Fade>

        {/* ── Image ── */}
        <Fade bottom duration={800} distance="40px" delay={150}>
          <div className="hero__image-wrap">
            <div className="hero__image-glow" aria-hidden="true" />
            <div className="hero__image-ring">
              <img
                src={profileImage}
                alt="Srimonchaari Padmanabhan Babu"
                className="hero__image"
                draggable={false}
                onContextMenu={e => e.preventDefault()}
              />
            </div>
          </div>
        </Fade>
      </div>

      {/* Scroll cue */}
      <div className="hero__scroll-cue" aria-hidden="true">
        <span className="hero__scroll-line" />
      </div>
    </section>
  );
}
